export default "__VITE_ASSET__DK99UBv7__"